/**
 * AnatomySettingsService — the integration's configuration. Admin only (Anatomy.Settings).
 *
 * Routes — /api/anatomy/settings
 *   - GET  /       — everything except the key (hasApiKey + last-four hint)
 *   - PUT  /       — save; a blank apiKey keeps the stored one
 *   - POST /test   — prove the URL + key with a cheap read; result recorded on the row
 */
import { BaseService } from '../base/BaseService';
export class AnatomySettingsService extends BaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? AnatomySettingsService.DEFAULT_SERVICE_PATH,
            basePath: AnatomySettingsService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    async get() {
        const r = await this.getRaw();
        if (!r.data)
            throw new Error(r.message ?? 'Could not read settings');
        return r.data;
    }
    getRaw() {
        return this.http.get(this.buildUrl());
    }
    async update(request) {
        const r = await this.updateRaw(request);
        if (!r.success || !r.data)
            throw new Error(r.message ?? 'Could not save settings');
        return r.data;
    }
    updateRaw(request) {
        return this.http.put(this.buildUrl(), request);
    }
    /** Returns the human-readable outcome; throws with the reason on failure. */
    async testConnection() {
        const r = await this.testConnectionRaw();
        if (!r.success)
            throw new Error(r.message ?? 'Connection test failed');
        return r.data ?? r.message ?? 'Connected';
    }
    testConnectionRaw() {
        return this.http.post(this.buildUrl(this.getEndpoint('test', 'test')), {});
    }
    /** DNS → TCP → TLS → HTTP from inside the container, plus the egress IP. `GET /diagnose` */
    async diagnose() {
        const r = await this.http.get(this.buildUrl(this.getEndpoint('diagnose', 'diagnose')));
        if (!r.data)
            throw new Error(r.message ?? 'Diagnostics did not run');
        return r.data;
    }
}
AnatomySettingsService.DEFAULT_SERVICE_PATH = 'anatomy';
AnatomySettingsService.BASE_PATH = 'api/anatomy/settings';
//# sourceMappingURL=AnatomySettingsService.js.map